import React, { forwardRef, ReactElement } from 'react'

import { OTPInput, REGEXP_ONLY_DIGITS } from 'input-otp'
import { useController } from 'react-hook-form'

import { mergeRefs } from 'Utils/index'

import ErrorMessage from 'Components/ErrorMessage'

import FormErrors from '../../FormErrors'

import OtpInputSlots from './OtpInputSlots'

const OTP_LENGTH = 6

const otpValidationRules = {
  required: false,
  minLength: {
    value: 6,
    message: 'Enter the 6-digit code',
  },
  pattern: /\d{6}/,
}

interface Props {
  canAutoSubmit: boolean
  children: ReactElement
  onSubmit: () => void
}

const Code = forwardRef<HTMLInputElement, Props>(({ canAutoSubmit, children, onSubmit }, ref) => {
  const { field } = useController({ name: 'code', defaultValue: '', rules: otpValidationRules })

  return (
    <div className="checkout-contact-flow__field-group">
      <div className="form-group mb-2">
        <label className="sr-only" htmlFor="customer-code">
          Verification code
        </label>
        <OTPInput
          {...field}
          ref={mergeRefs(ref, field.ref)}
          autoComplete="one-time-code"
          className="checkout-otp-input__input"
          containerClassName="checkout-contact-flow__otp checkout-otp-input"
          id="customer-code"
          inputMode="numeric"
          maxLength={OTP_LENGTH}
          pattern={REGEXP_ONLY_DIGITS}
          render={({ slots }) => <OtpInputSlots slots={slots} />}
          spellCheck={false}
          type="text"
          onComplete={() => {
            if (!canAutoSubmit) return
            onSubmit()
          }}
        />
        <ErrorMessage as={FormErrors} name="code" />
      </div>
      {children}
    </div>
  )
})

Code.displayName = 'Code'

export default Code
